import Features, { getFeaturesWidth } from './Features';
export { getFeaturesWidth };
export default Features;
